<template>
  <n-message-provider :max="1">
    <div id="root-app">
      <SwitchDarkLightMode />
      <router-view />
    </div>
  </n-message-provider>
</template>

<script>
import { NMessageProvider } from "naive-ui";
import SwitchDarkLightMode from "@/components/SwitchDarkLightMode.vue";
export default {
  name: "App",
  components: {
    NMessageProvider,
    SwitchDarkLightMode,
  },
};
</script>

<style lang="less" scoped>
#root-app {
  width: 100vw;
  height: 100vh;
}
</style>
